// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"e6eacb32","522":"e6eacb32","738":"e6eacb32","901":"e6eacb32","928":"e6eacb32"}[chunkId] + ".chunk.css";
};